export default __webpack_public_path__ + "static/media/hero_1920.e6466b5d.jpg";